<template>
    <div class="view view__lms_user_workspaces_list">
        <lms-user-workspace-list/>
    </div>
</template>

<script>
import LmsUserWorkspaceList from '@/components/lms/user/workspaces/LmsUserWorkspaceList'
export default {
  name: 'view-lms-user-workspace-list',
  components: { LmsUserWorkspaceList },
  computed: {
    secondStageToken () {
      return this.$store.getters.getAuthUserSecondStageTokenData
    }
  },
  methods: {
    getLmsUserWorkspaces () {
      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('authUserInitializeProfiles', { force: true })
      this.$store.dispatch('lmsUserGetWorkspaces').then(() => {
        this.$eventBus.$emit('stop-loading')
      })
    }
  },
  created () {
    this.getLmsUserWorkspaces()
  }
}
</script>
